<template>
    <div>
        <Header></Header>
        <div class="devcenterContent">
            <iframe id="myContents" class="iframeContent" :src="url"
                frameborder="0"></iframe>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from '../../components/Footer.vue'
    import Header from '../../components/Header.vue'
    import axios from 'axios'
    export default {
        name: "index",
        components: {
            Footer,
            Header
        },
        data() {
            return {
                url: '',
                jishu:0
            }
        },
        mounted() {
            const language = localStorage.getItem('language')
            let that = this
            axios.get('config/iframeConfig.json').then(res => {
                if(language==='en'){
                    this.url = res.devcenterEn
                    if (res.data) {
                        this.url = res.data.devcenterEn
                    }
                }else{
                    this.url = res.devcenter
                    if (res.data) {
                        this.url = res.data.devcenter
                    }
                }
            })
            window.addEventListener('message', function (e) {
                let value = e.data;
                if (e.data) {
                    var iframe = document.getElementById("myContents");
                    iframe.height = Number(value);
                }

            })
            this.jishu = 0
            this.timer = setInterval(() =>{
                try {
                    
                    let a = document.getElementById('myContents').contentWindow
                    a.document.getElementById('new-nav').style.display='none'
                    a.document.getElementsByClassName('app-main')[0].style['margin-top']='0px'

                    document.getElementById('new-nav').style.display='none'
                    document.getElementsByClassName('app-main')[0].style['margin-top']='0px'
                } catch (error) {
                    console.log(error);
                }
                that.jishu ++
                if(that.jishu>30){
                    clearInterval(that.timer)
                }
            },500)


            // const dd = (iframe.contentWindow || iframe.contentDocument)
            // var app = dd.document.getElementsByClassName("app-wrapper");
            // var bHeight = app.document.body.scrollHeight;
            // iframe.height = bHeight;
            // this.$nextTick(() => {

            //     setTimeout(() =>{

            //     },500)
            // })

            // setInterval(function(){
            //     var iframe = document.getElementById("myContents");
            //     var bHeight = iframe.contentWindow.document.body.scrollHeight;
            //     var dHeight = iframe.contentWindow.document.documentElement.scrollHeight;
            //     var height = Math.min(bHeight, dHeight);
            //     iframe.height = height;
            // }, 100);
            // let iframe=document.getElementById("myContents");
            // let height=iframe.contentWindow.document.body.scrollHeight+500;
            // iframe.setAttribute('height',height);
            // setInterval(function(
            //     iframes[0].setAttribute('height',iframes[0].contentWindow.document.body.scrollHeight);
            // ),1000);
            // setInterval(function(){
            //     let iframes=document.getElementsByTagName('iframe');
            // let height=iframes[0].contentWindow.document.body.scrollHeight;
            //     iframes[0].setAttribute('height',height);
            // },1000);
        }

    }
</script>

<style lang="scss" scoped>
.devcenterContent {
    width: 100%;
    height: auto;
}

.iframeContent {
    width: 100%;
    /* height: auto; */
    height: 850px;
}

</style>

<style lang="scss">
#new-nav{
    display: none;
}
.app-main{
    margin-top: 0;
}
</style>